import type { Point } from '../../../shared/game/world-types.js';

interface Landmark extends Point { name: string }

const ENTER_RADIUS = 40, LEAVE_RADIUS = 65;

/** Announces a named area in the center of the screen when the party first approaches it. */
export class AreaBanner {
  private current: string | null = null;
  constructor(private readonly element: HTMLElement) {}
  reset() { this.current = null; this.element.hidden = true; }
  update(landmarks: Landmark[], party: Point[]) {
    const distance = (landmark: Landmark) => Math.min(...party.map(p => Math.hypot(p.x - landmark.x, p.z - landmark.z)));
    if (!party.length) return;
    const held = landmarks.find(landmark => landmark.name === this.current);
    if (held && distance(held) < LEAVE_RADIUS) return;
    const near = landmarks.map(landmark => ({ landmark, d: distance(landmark) })).filter(item => item.d < ENTER_RADIUS).sort((a, b) => a.d - b.d)[0]?.landmark;
    this.current = near?.name ?? null;
    if (near) this.show(near.name);
  }
  private show(name: string) {
    this.element.textContent = name; this.element.hidden = false;
    this.element.classList.remove('showing'); void this.element.offsetWidth; this.element.classList.add('showing');
  }
}
